fragment ProductAttributeFragment on ProductAttribute {
    id

    key
    slug
    label

    required

    ui_type

    readonly
    system
    media_association
    translatable

    validation

    settings
}